import { useRef as u } from "react";
function c(t) {
  const e = u(t);
  e.current = t;
  function r(...n) {
    return e.current(...n);
  }
  return r;
}
export {
  c as default
};
